import { TIIndicatorPointToEMACloudPointMapper } from "../../mappers/data-point/ti-indicator-point-to-ema-cloud-point.mapper";
import { TIIndicatorDataModel } from "../../models/data-point/ti-indicator-data.model";
import { IndicatorOptionModel } from "../../models/drop-down-list/indicator-option.model";
import { TiChartSeriesComponent } from "../ti-chart-series.component";

export class EMACloudIndicatorComponent {
    public id = '';

    private tiChartSeries: TiChartSeriesComponent;

    constructor(tiChartSeries: TiChartSeriesComponent) {
        this.tiChartSeries = tiChartSeries;
    }

    public setData(indicatorData: TIIndicatorDataModel) {
        const series1 = this.tiChartSeries.highStockChart.series.find((x: any) => x.name == indicatorData.getClassName() + 'ema-cloud-line-1');
        const dataPoints = TIIndicatorPointToEMACloudPointMapper.mapPoints(indicatorData);

        indicatorData.zones = dataPoints.zones;

        series1?.update({
            zones: dataPoints.zones,
            zoneAxis: 'x'
        });
        series1?.setData(dataPoints.points, true, false, true);
    }

    public clearData(indicatorData: TIIndicatorDataModel) {
        const series1 = this.tiChartSeries.highStockChart.series.find((x: any) => x.name == indicatorData.getClassName() + 'ema-cloud-line-1');
        series1?.setData([], true, false, true);
    }

    public remove(indicatorData: TIIndicatorDataModel) {
        const series1 = this.tiChartSeries.highStockChart.series.find((x: any) => x.name == indicatorData.getClassName() + 'ema-cloud-line-1');

        series1?.remove();
    }

    public hasSeries(indicatorData: TIIndicatorDataModel): boolean {
        const series1 = this.tiChartSeries.highStockChart.series.find((x: any) => x.name == indicatorData.getClassName() + 'ema-cloud-line-1');

        return !!series1;
    }

    public updateIndicators(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel, tiIndicatorDataIndex: number, isUpdate: boolean) {
        const series1 = this.tiChartSeries.highStockChart.series.find((x: any) => x.name == indicatorData.getClassName() + 'ema-cloud-line-1');
        if (!indicatorData?.childIndicators?.[0].points?.length || !series1) {
            return;
        }

        const indicatorDataPoint = indicatorData?.points?.length ? indicatorData?.points[indicatorData?.points.length - 1] : null;
        const childIndicatorDataPoint = indicatorData?.childIndicators?.[0].points?.length ? indicatorData?.childIndicators?.[0].points[indicatorData?.childIndicators?.[0].points.length - 1] : null;
        if (!indicatorDataPoint || !childIndicatorDataPoint) {
            return;
        }

        const mappedResult = [indicatorDataPoint.xValue, indicatorDataPoint.value, childIndicatorDataPoint.value];
        if (isUpdate) {
            const lastChartBar1 = series1.points.find((x: any) => x.x == indicatorDataPoint.xValue);
            const tiIndicatorDataPointIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[0].points.findIndex(x => x.xValue == indicatorDataPoint.xValue);
            // update to main ti indicator data points
            if (tiIndicatorDataPointIndex > -1) {
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].points[tiIndicatorDataPointIndex] = indicatorDataPoint;
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[0].points[tiIndicatorDataPointIndex] = childIndicatorDataPoint;
            }

            const dataPoints = TIIndicatorPointToEMACloudPointMapper.mapPoints(this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
            indicatorData.zones = dataPoints.zones;

            if (!lastChartBar1) {
                series1?.update?.({
                    zones: dataPoints.zones,
                    zoneAxis: 'x'
                });
                series1.setData?.(dataPoints.points, true, false, true);
            } else {
                series1?.update({
                    zones: dataPoints.zones,
                    zoneAxis: 'x'
                });
                lastChartBar1.update?.(mappedResult, false);
            }
        } else {
            this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].points.push(indicatorDataPoint);
            this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[0].points.push(childIndicatorDataPoint);
            
            const dataPoints = TIIndicatorPointToEMACloudPointMapper.mapPoints(this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
            indicatorData.zones = dataPoints.zones;
            series1?.update?.({
                zones: dataPoints.zones,
                zoneAxis: 'x'
            });

            series1.addPoint?.(mappedResult, false);
        }
    }

    public updateHistory(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel) {
        const series1 = this.tiChartSeries.highStockChart.series.find((x: any) => x.name == indicatorData.getClassName() + 'ema-cloud-line-1');
        if (!indicatorData?.childIndicators?.[0].points?.length || !series1) {
            return;
        }

        const dataPoints = TIIndicatorPointToEMACloudPointMapper.mapPoints(indicatorData);

        indicatorData.zones = dataPoints.zones;
        series1.update({
            zones: dataPoints.zones,
            zoneAxis: 'x'
        });
        series1.setData(dataPoints.points, true, false, true);
    }
}